module.exports = __webpack_public_path__ + "img/FITOTERAPIA.be31ba02.png";